import { useEffect } from 'react';

import { Page } from '@/components/Layout';
import { NewBridgeLink } from '@/components/NewBridgeLink';
import { t, useLocale } from '@/i18n';

import styles from './pages.module.css';

export function NotFoundPage(): React.JSX.Element {
  const { code } = useLocale();
  useEffect(() => {
    document.title = t('notFound.docTitle');
  }, [code]);
  return (
    <Page>
      <section className={[styles.card, styles.statusCard].join(' ')} style={{ marginTop: 80 }}>
        <h2>{t('notFound.title')}</h2>
        <p>{t('notFound.text')}</p>
        <div className={styles.statusActions}>
          <NewBridgeLink>{t('notFound.home')}</NewBridgeLink>
        </div>
      </section>
    </Page>
  );
}
